import React, {useMemo} from 'react';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

const ContentBuilt = ({data, cloneSource = false}) => {
	const {managerRepository} = useGeneralProvider();
	const isPreviewMode = managerRepository.getContentMgr().isPreviewMode();
	const cmsProvider = useMemo(() => managerRepository.getContentMgr().getCMSProvider(), [isPreviewMode]);

	return useMemo(() => {
		if (!data) {
			return null;
		}

		return cmsProvider.getBuilder().build(data as object, cloneSource) as React.ReactElement;
	}, [data, isPreviewMode]);
};

export default ContentBuilt;
